import { render } from "./UiCheckSet.vue?vue&type=template&id=39af12aa&scoped=true"
import script from "./UiCheckSet.vue?vue&type=script&lang=js"
export * from "./UiCheckSet.vue?vue&type=script&lang=js"

import "./UiCheckSet.vue?vue&type=style&index=0&id=39af12aa&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39af12aa"]])

export default __exports__